import {Map} from "immutable"
import undoable  from 'redux-undo'
import constants from '../containers/Constants'
import Immutable from 'immutable'

const clipboard = (clipboard = false, action) => {
    switch (action.type) {

        case 'COPY_BUTTON_ACTIONS':
            clipboard = action.actions
            return clipboard;
        default:
            console.log('clipboard', clipboard)
            return clipboard;
    }
}

export default clipboard